module.exports = __webpack_public_path__ + "static/media/sm.3b1c9fb5.svg";